import React from "react";
import { Stepper, Step, StepLabel, StepConnector, Box } from "@mui/material";
import { FaCheckCircle } from "react-icons/fa";
import { FaRegCircleDot } from "react-icons/fa6";
import { styled } from "@mui/material/styles";
import { stepConnectorClasses } from "@mui/material/StepConnector";

// Custom StepConnector
const CustomStepConnector = styled(StepConnector)(({ theme }) => ({
    [`&.${stepConnectorClasses.active} .${stepConnectorClasses.line}`]: {
        borderColor: "#12538B",
    },
    [`&.${stepConnectorClasses.completed} .${stepConnectorClasses.line}`]: {
        borderColor: "#12538B",
    },
    [`& .${stepConnectorClasses.line}`]: {
        borderColor: "#BDBDBD",
        borderTopWidth: 2,
    },
}));

// Custom StepIcon to use different icons for active and completed steps
const StepIcon = (props) => {
    const { active, completed } = props;

    return (
        <Box
            sx={{
                width: 24,
                height: 24,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                cursor: "pointer", 
                color: completed || active ? "#12538B" : "#BDBDBD",
            }}
        >
            {completed ? (
                <FaCheckCircle size={24} />
            ) : (
                <FaRegCircleDot size={24} /> // Use FaRegCircleDot for active or inactive steps
            )}
        </Box>
    );
};

// StepperComponent
const StepperComponent = ({ steps, activeStep, onStepClick,direction }) => {
    return (
        <Stepper
            activeStep={activeStep}
            alternativeLabel
            connector={<CustomStepConnector />}
            sx={{
                flexDirection:direction==="rtl"?"row-reverse":"row",
                marginBottom: 4,
                "& .MuiStepLabel-label": {
                    color: "#333333",
                    fontSize: '16px',
                    fontWeight: 500,
                    lineHeight: "16.41px",
                
                        cursor: "pointer", 
                     

                },
            }}
        >
            {steps.map((label, index) => (
                <Step key={index}  onClick={() => onStepClick(index)}  >
                    <StepLabel StepIconComponent={StepIcon}  sx={{
            cursor: "pointer",
          }}>{label}</StepLabel>
                </Step>
            ))}
        </Stepper>
    );
};

export default StepperComponent;
